// Copyright (c) Docugami, Inc. All rights reserved.

import styled from "styled-components";
import { CountText } from "./CountText";
import { ReactNode } from "react";

const HeaderRoot = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 5px;
    box-sizing: border-box;
`;

interface CardHeaderProps {
    count: number;
    className?: string;
    children?: ReactNode;
    showSingle?: boolean;
}

export const CardHeader = (props: CardHeaderProps): JSX.Element => {
    return (
        <HeaderRoot className={props.className}>
            {(!!props.showSingle || props.count > 1) && <CountText count={props.count} itemName="instance" />}
            {props.children}
        </HeaderRoot>
    );
}
